function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ('value' in descriptor)
            descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps)
        _defineProperties(Constructor.prototype, protoProps);
    if (staticProps)
        _defineProperties(Constructor, staticProps);
    return Constructor;
}
import utils from '../utils.js';
export var Slider = function () {
    function Slider(el, min, max, step) {
        var _this = this;
        var value = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
        var callbacks = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
        _classCallCheck(this, Slider);
        var THIS = this;
        this.el = el;
        this.min = Number(min);
        this.max = Number(max);
        this.step = Number(step);
        this.value = Number(value) == NaN ? value : Number(value);
        this.callbacks = callbacks;
        this.track = this.el.querySelector('.slider-track');
        this.bar = this.track.querySelector('.slider-bar');
        this.thumbTrack = this.track.querySelector('.slider-thumb-track');
        this.thumb = this.track.querySelector('.slider-thumb');
        this.el.addEventListener(utils.nameMap.dragStart, function (event) {
            var e = event || window.event;
            var trackLength = THIS.track.offsetWidth;
            var nMax = THIS.thumbTrack.offsetWidth;
            nMax = nMax ? nMax : trackLength;
            var thumbTrackX = (trackLength - nMax) / 2;
            var clientX = e.clientX || e.changedTouches[0].clientX;
            var nLeft = THIS.el.getBoundingClientRect().left;
            var nLength = clientX - nLeft - thumbTrackX;
            nLength = nLength >= nMax ? nMax : nLength <= 0 ? 0 : nLength;
            var value = THIS.step ? Math.round(nLength / nMax * (THIS.max - THIS.min) / THIS.step) * THIS.step + THIS.min : nLength / nMax * (THIS.max - THIS.min) + THIS.min;
            if (THIS.callbacks.start) {
                THIS.callbacks.start(value);
            }
            if (THIS.value != value) {
                THIS.update(value);
            }
            var mousemoveEvent = function mousemoveEvent(event) {
                var e = event || window.event;
                e.preventDefault();
                e.stopPropagation();
                var clientX = e.clientX || e.changedTouches[0].clientX;
                var nLength = clientX - nLeft - thumbTrackX;
                nLength = nLength >= nMax ? nMax : nLength <= 0 ? 0 : nLength;
                var value = THIS.step ? Math.round(nLength / nMax * (THIS.max - THIS.min) / THIS.step) * THIS.step + THIS.min : nLength / nMax * (THIS.max - THIS.min) + THIS.min;
                if (THIS.value != value) {
                    THIS.update(value, true);
                }
                window.getSelection ? window.getSelection().removeAllRanges() : document.selection.empty();
            };
            var removeEvent = function removeEvent(event) {
                var e = event || window.event;
                e.stopPropagation();
                window.getSelection ? window.getSelection().removeAllRanges() : document.selection.empty();
                document.removeEventListener(utils.nameMap.dragMove, mousemoveEvent);
                document.removeEventListener(utils.nameMap.dragEnd, removeEvent);
                if (THIS.callbacks.end) {
                    THIS.callbacks.end(value);
                }
            };
            document.addEventListener(utils.nameMap.dragMove, mousemoveEvent);
            document.addEventListener(utils.nameMap.dragEnd, removeEvent);
        });
        if (this.callbacks.created) {
            this.callbacks.created(this);
        }
        setTimeout(function () {
            _this.update(_this.value, false);
        }, 0);
    }
    _createClass(Slider, [
        {
            key: 'change',
            value: function change(value) {
                this.value = value <= this.min ? this.min : value >= this.max ? this.max : value;
                var per = (this.value - (this.min + 2)) / (this.max - this.min - 4);
                this.thumb.style.left = per * 100 + '%';
                this.bar.style.width = Math.max(Math.min(per, 1), 0.01) * 100 + '%';
                if (this.callbacks.change) {
                    var _this$callbacks;
                    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                        args[_key - 1] = arguments[_key];
                    }
                    (_this$callbacks = this.callbacks).change.apply(_this$callbacks, [value].concat(args));
                }
            }
        },
        {
            key: 'update',
            value: function update(value) {
                for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
                    args[_key2 - 1] = arguments[_key2];
                }
                this.change.apply(this, [value].concat(args));
                if (this.callbacks.update) {
                    var _this$callbacks2;
                    (_this$callbacks2 = this.callbacks).update.apply(_this$callbacks2, [value].concat(args));
                }
            }
        }
    ]);
    return Slider;
}();
export var Slider_vertical = function () {
    function Slider_vertical(el, min, max, step) {
        var _this2 = this;
        var value = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
        var callbacks = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
        _classCallCheck(this, Slider_vertical);
        var THIS = this;
        this.el = el;
        this.min = Number(min);
        this.max = Number(max);
        this.step = Number(step);
        this.value = Number(value) == NaN ? value : Number(value);
        this.callbacks = callbacks;
        this.track = this.el.querySelector('.slider-track');
        this.bar = this.track.querySelector('.slider-bar');
        this.thumbTrack = this.track.querySelector('.slider-thumb-track');
        this.thumb = this.track.querySelector('.slider-thumb');
        this.el.addEventListener(utils.nameMap.dragStart, function (event) {
            var e = event || window.event;
            var trackLength = THIS.track.offsetHeight;
            var nMax = THIS.thumbTrack.offsetHeight;
            nMax = nMax ? nMax : trackLength;
            var thumbTrackY = (trackLength - nMax) / 2;
            var clientY = e.clientY || e.changedTouches[0].clientY;
            var nTop = THIS.el.getBoundingClientRect().top;
            var nLength = nMax - (clientY - nTop - thumbTrackY);
            nLength = nLength >= nMax ? nMax : nLength <= 0 ? 0 : nLength;
            var value = THIS.step ? Math.round(nLength / nMax * (THIS.max - THIS.min) / THIS.step) * THIS.step + THIS.min : nLength / nMax * (THIS.max - THIS.min) + THIS.min;
            var per = (value - (THIS.min + 6)) / (THIS.max - THIS.min - 12);
            if (THIS.callbacks.start) {
                THIS.callbacks.start(value);
            }
            if (THIS.value != value) {
                THIS.update(value, true);
            }
            THIS.thumb.style.top = (1 - per) * 100 + '%';
            THIS.bar.style.height = Math.max(Math.min(per, 1), 0) * 100 + '%';
            var mousemoveEvent = function mousemoveEvent(event) {
                var e = event || window.event;
                e.preventDefault();
                window.getSelection ? window.getSelection().removeAllRanges() : document.selection.empty();
                var clientY = e.clientY || e.changedTouches[0].clientY;
                var nLength = nMax - (clientY - nTop - thumbTrackY);
                nLength = nLength >= nMax ? nMax : nLength <= 0 ? 0 : nLength;
                var value = THIS.step ? Math.round(nLength / nMax * (THIS.max - THIS.min) / THIS.step) * THIS.step + THIS.min : nLength / nMax * (THIS.max - THIS.min) + THIS.min;
                if (THIS.value != value) {
                    THIS.update(value, true);
                }
            };
            var removeEvent = function removeEvent(event) {
                var e = event || window.event;
                e.preventDefault();
                document.removeEventListener(utils.nameMap.dragMove, mousemoveEvent);
                document.removeEventListener(utils.nameMap.dragEnd, removeEvent);
                if (THIS.callbacks.end) {
                    THIS.callbacks.end(value);
                }
            };
            document.addEventListener(utils.nameMap.dragMove, mousemoveEvent);
            document.addEventListener(utils.nameMap.dragEnd, removeEvent);
        });
        if (this.callbacks.created) {
            this.callbacks.created(this);
        }
        setTimeout(function () {
            _this2.update(_this2.value, false);
        }, 0);
    }
    _createClass(Slider_vertical, [
        {
            key: 'change',
            value: function change(value) {
                this.value = Math.max(Math.min(value, this.max), this.min);
                var per = (this.value - (this.min + 6)) / (this.max - this.min - 12);
                this.thumb.style.top = (1 - per) * 100 + '%';
                this.bar.style.height = Math.max(Math.min(per, 1), 0) * 100 + '%';
                if (this.callbacks.change) {
                    var _this$callbacks3;
                    for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
                        args[_key3 - 1] = arguments[_key3];
                    }
                    (_this$callbacks3 = this.callbacks).change.apply(_this$callbacks3, [value].concat(args));
                }
            }
        },
        {
            key: 'update',
            value: function update(value) {
                for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
                    args[_key4 - 1] = arguments[_key4];
                }
                this.change.apply(this, [value].concat(args));
                if (this.callbacks.update) {
                    var _this$callbacks4;
                    (_this$callbacks4 = this.callbacks).update.apply(_this$callbacks4, [value].concat(args));
                }
            }
        }
    ]);
    return Slider_vertical;
}();
export var Picker = function () {
    function Picker(group) {
        var _this3 = this;
        var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        var callbacks = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        _classCallCheck(this, Picker);
        var THIS = this;
        this.group = group;
        this.items = group.querySelectorAll('.picker-item');
        this.value = value;
        this.callbacks = callbacks;
        this.valueList = [];
        this.items.forEach(function (item) {
            _this3.valueList.push(item.getAttribute('data-value'));
            item.addEventListener('click', function () {
                THIS.pick(item.getAttribute('data-value'));
            });
        });
        if (this.callbacks.created) {
            this.callbacks.created(this);
        }
        setTimeout(function () {
            _this3.pick(_this3.value, 'nonotice');
        }, 0);
    }
    _createClass(Picker, [
        {
            key: 'change',
            value: function change(value) {
                this.items.forEach(function (n, i) {
                    if (n.getAttribute('data-value') == value) {
                        n.classList.add('picked');
                    } else {
                        n.classList.remove('picked');
                    }
                });
                this.value = value;
                if (this.callbacks.change) {
                    var _this$callbacks5;
                    for (var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
                        args[_key5 - 1] = arguments[_key5];
                    }
                    (_this$callbacks5 = this.callbacks).change.apply(_this$callbacks5, [value].concat(args));
                }
            }
        },
        {
            key: 'pick',
            value: function pick(value) {
                for (var _len6 = arguments.length, args = new Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
                    args[_key6 - 1] = arguments[_key6];
                }
                this.change.apply(this, [value].concat(args));
                if (this.callbacks.pick) {
                    var _this$callbacks6;
                    (_this$callbacks6 = this.callbacks).pick.apply(_this$callbacks6, [value].concat(args));
                }
            }
        }
    ]);
    return Picker;
}();
export var MultiPicker = function () {
    function MultiPicker(group) {
        var _this4 = this;
        var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        var callbacks = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        _classCallCheck(this, MultiPicker);
        var THIS = this;
        this.group = group;
        this.items = group.querySelectorAll('.picker-item');
        this.value = new Set();
        this.callbacks = callbacks;
        this.valueList = [];
        this.domMap = new Map();
        this.items.forEach(function (item) {
            _this4.valueList.push(item.getAttribute('data-value'));
            _this4.domMap.set(item.getAttribute('data-value'), item);
            if (value.includes(item.getAttribute('data-value'))) {
                _this4.pick(item.getAttribute('data-value'), 'nonotice');
            }
            item.addEventListener('click', function () {
                var val = this.getAttribute('data-value');
                if (THIS.value.has(val)) {
                    THIS.unpick(val);
                } else {
                    THIS.pick(val);
                }
            });
        });
        if (this.callbacks.created) {
            this.callbacks.created(this);
        }
        setTimeout(function () {
            _this4.pick(_this4.value, 'nonotice');
        }, 0);
    }
    _createClass(MultiPicker, [
        {
            key: 'pick',
            value: function pick(val) {
                var _this5 = this;
                for (var _len7 = arguments.length, args = new Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {
                    args[_key7 - 1] = arguments[_key7];
                }
                if (typeof val == 'string') {
                    this.domMap.get(val).classList.add('picked');
                    this.value.add(val);
                    if (this.callbacks.pick) {
                        var _this$callbacks7;
                        (_this$callbacks7 = this.callbacks).pick.apply(_this$callbacks7, [val].concat(args));
                    }
                } else if (typeof val == 'array') {
                    this.items.forEach(function (n) {
                        _this5.domMap.get(n).classList.add('picked');
                        _this5.value.add(n);
                        if (_this5.callbacks.pick) {
                            var _this5$callbacks;
                            (_this5$callbacks = _this5.callbacks).pick.apply(_this5$callbacks, [n].concat(args));
                        }
                    });
                }
                if (this.callbacks.update) {
                    var _this$callbacks8;
                    (_this$callbacks8 = this.callbacks).update.apply(_this$callbacks8, [this.value].concat(args));
                }
            }
        },
        {
            key: 'unpick',
            value: function unpick(val) {
                var _this6 = this;
                for (var _len8 = arguments.length, args = new Array(_len8 > 1 ? _len8 - 1 : 0), _key8 = 1; _key8 < _len8; _key8++) {
                    args[_key8 - 1] = arguments[_key8];
                }
                if (typeof val == 'string') {
                    this.domMap.get(val).classList.remove('picked');
                    this.value['delete'](val);
                    if (this.callbacks.unpick) {
                        var _this$callbacks9;
                        (_this$callbacks9 = this.callbacks).unpick.apply(_this$callbacks9, [val].concat(args));
                    }
                } else if (typeof val == 'array') {
                    this.items.forEach(function (n) {
                        _this6.domMap.get(n).classList.remove('picked');
                        _this6.value['delete'](n);
                        if (_this6.callbacks.unpick) {
                            var _this6$callbacks;
                            (_this6$callbacks = _this6.callbacks).unpick.apply(_this6$callbacks, [n].concat(args));
                        }
                    });
                }
                if (this.callbacks.update) {
                    var _this$callbacks10;
                    (_this$callbacks10 = this.callbacks).update.apply(_this$callbacks10, [this.value].concat(args));
                }
            }
        }
    ]);
    return MultiPicker;
}();
export var Switch = function () {
    function Switch(el) {
        var _this7 = this;
        var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var callbacks = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        _classCallCheck(this, Switch);
        var THIS = this;
        this.el = el;
        this.value = value;
        this.callbacks = callbacks;
        this.el.addEventListener('click', function () {
            _this7.update(!_this7.value);
        });
        if (this.callbacks.created) {
            this.callbacks.created(this);
        }
        setTimeout(function () {
            _this7.update(_this7.value, 'nonotice');
        }, 0);
    }
    _createClass(Switch, [
        {
            key: 'on',
            value: function on() {
                this.value = true;
                this.el.classList.add('switch-on');
                if (this.callbacks.on) {
                    var _this$callbacks11;
                    (_this$callbacks11 = this.callbacks).on.apply(_this$callbacks11, arguments);
                }
                if (this.callbacks.update) {
                    var _this$callbacks12;
                    (_this$callbacks12 = this.callbacks).update.apply(_this$callbacks12, arguments);
                }
            }
        },
        {
            key: 'off',
            value: function off() {
                this.value = false;
                this.el.classList.remove('switch-on');
                if (this.callbacks.off) {
                    var _this$callbacks13;
                    (_this$callbacks13 = this.callbacks).off.apply(_this$callbacks13, arguments);
                }
                if (this.callbacks.update) {
                    var _this$callbacks14;
                    (_this$callbacks14 = this.callbacks).update.apply(_this$callbacks14, arguments);
                }
            }
        },
        {
            key: 'update',
            value: function update(value) {
                for (var _len9 = arguments.length, args = new Array(_len9 > 1 ? _len9 - 1 : 0), _key9 = 1; _key9 < _len9; _key9++) {
                    args[_key9 - 1] = arguments[_key9];
                }
                if (value) {
                    this.on.apply(this, args);
                } else {
                    this.off.apply(this, args);
                }
            }
        }
    ]);
    return Switch;
}();